import create from 'zustand/vanilla';
import { persist, createJSONStorage, StateStorage } from 'zustand/middleware';
import { AES, enc } from 'crypto-js';
import { env } from '@/constant/configure';
import api from '@/helpers/api_helper';

interface SessionState {
    userId: string;
    accessToken: string;
    // mallUserId: string,
    mallId: string;
    expiresIn: string;
}

export interface SessionStore extends SessionState {
    hasSession: boolean;

    setSession: (session: SessionState) => void;
    updateToken: (accessToken: string, expiresIn: string) => void;
    clearSession: () => void;
    syncWithStorage: (v?: string) => Promise<boolean>;
}

const initializeState = {
    userId: '',
    // mallUserId: '',
    mallId: '',
    accessToken: '',
    expiresIn: '',
    hasSession: false,
};

const persistStore = window.localStorage;
const storage: StateStorage = {
    getItem: (name: string): string | null => {
        // console.log('getter-session-persist');
        const value = persistStore.getItem(name) || null;
        if (!value) return null;

        if (env !== 'prd') console.log('getter-session-persist', AES.decrypt(value, name).toString(enc.Utf8));

        return AES.decrypt(value, name).toString(enc.Utf8) || null;
    },
    setItem: (name: string, value: string) => {
        try {
            if (env !== 'prd') console.log('setter-session-persist', value);

            const session = JSON.parse(value)?.state || {};
            const { accessToken, expiresIn } = session;

            const encrypted = AES.encrypt(value, name).toString();
            persistStore.setItem(name, encrypted);
            if (!!accessToken && !!expiresIn) {
                persistStore.setItem(name, encrypted);
            } else {
                persistStore.removeItem(name);
            }

            // persistStore.setItem(name, encrypted);
        } catch (e) {
            console.error(e);
        }
        // console.log('setter-session-persist', value);
        // const encrypted = AES.encrypt(value, name).toString();
        // persistStore.setItem(name, encrypted);
    },
    removeItem: (name: string) => {
        if (env !== 'prd') console.log('remove-session-persist');
        persistStore.removeItem(name);
    },
};

export const sessionStore = create<SessionStore>()(
    persist(
        (set) => ({
            ...initializeState,

            setSession: (session) => {
                const { accessToken, mallId, expiresIn, userId } = session;

                const data = {
                    userId: userId,
                    accessToken: accessToken,
                    mallId: mallId,
                    // mallUserId: session.mallUserId,
                    expiresIn: expiresIn,
                    hasSession: !!(accessToken && mallId),
                };

                console.log('setSessionStore', data);

                set((state) => data);
            },

            updateToken: (accessToken, expiresIn) => {
                set((state) => ({
                    accessToken: accessToken,
                    expiresIn: expiresIn,
                }));
            },

            clearSession: () => {
                set(initializeState);
                sessionStore.persist.clearStorage();
            },

            syncWithStorage: async (v?: string) => {
                console.log('%c syncWithStorage', 'background-color:rgba(0,255,0,0.5); color:green;', v);
                const cs = sessionStore.getState();

                const dec = AES.decrypt(v || '', 'flowing-manager-session').toString(enc.Utf8) || null;

                const newState = !!dec
                    ? JSON.parse(dec).state
                    : {
                          accessToken: '',
                      };

                if (newState.accessToken !== cs.accessToken) {
                    if (!!newState.accessToken) {
                        api.defaults.headers.common['Authorization'] = `Bearer ${newState.accessToken}`;
                        await sessionStore.persist.rehydrate();
                    } else {
                        // 다른 탭에서 로그아웃: 스토리지가 비어 rehydrate로는 초기화되지 않으므로 직접 초기화
                        delete api.defaults.headers.common['Authorization'];
                        set(initializeState);
                    }
                    return true;
                } else {
                    return false;
                }
            },
        }),
        {
            name: 'flowing-manager-session',
            // storage: createJSONStorage(() => sessionStorage),
            storage: createJSONStorage(() => storage),
            // onRehydrateStorage: (state) => {
            //     const checkStorage = !!persistStore.getItem('flowing-manager-session');
            //     if (!checkStorage && !!state) {
            //         // console.log('state', state)
            //         setState({
            //             ...state,
            //             ...initializeState,
            //         });
            //     }
            //     // console.log('test-onRehydrateStorage', state)
            // },
        },
    ),
);

const { getState, setState, subscribe, destroy } = sessionStore;

export default sessionStore;
